<div class="col">
  <h3>Limite Pagamento ECG por Terceiros</h3>
</div>
<section class="container">
  <div class="bn-form-group row">
    <div class="d-flex justify-content-end">
      <button
        *ngIf="modoEdicao"
        type="button"
        class="btn btn-primary"
        (click)="cancelarEdicao()"
      >
        Cancelar
      </button>
      <button
        *ngIf="!modoEdicao"
        type="button"
        class="btn btn-primary"
        routerLink=".."
      >
        Voltar
      </button>

      <button
        *ngIf="modoEdicao && temTipoLimiteSelecionado"
        type="button"
        class="btn btn-primary"
        (click)="salvar()"
      >
        Enviar
      </button>

      <button
        type="button"
        class="btn btn-primary"
        ngbTooltip="Utilize esta opção para atualizar o valor do limite"
        *ngIf="!modoEdicao"
        [disabled]="naoTemTipoLimiteSelecionado"
        (click)="novoCadastro()"
      >
        Atualizar limite
      </button>

      <button
        type="button"
        class="btn btn-primary"
        ngbTooltip="Utilize esta opção apenas se o valor tiver sido cadastrado incorretamente e você desejar corrigi-lo"
        *ngIf="!modoEdicao"
        [disabled]="naoTemTipoLimiteSelecionado"
        (click)="corrigirLimite()"
      >
        Corrigir limite
      </button>
    </div>
  </div>
  <form [formGroup]="formGroup">
    <div class="row">
      <div class="bn-form-group col-8">
        <label class="form-label">Pagamento ECG feito Por: </label>
        <select
          class="form-control"
          formControlName="ideTipoPagamentoEcgTerceiro"
        >
          <option [value]="null"></option>
          <option *ngFor="let tipo of tipos" [value]="tipo.ide">
            {{ tipo.nomeTipoPagamentoEcgTerceiro }}
          </option>
        </select>
      </div>
    </div>
    <div class="row" *ngIf="temTipoLimiteSelecionado">
      <div class="bn-form-group col-4">
        <label class="form-label">Val. limite anterior: </label>
        <input
          type="text"
          class="form-control"
          formControlName="valorLimiteAnterior"
          name="valorLimiteAnterior"
          bnMask="MOEDA"
        />
      </div>
      <div class="bn-form-group col-4">
        <label class="form-label">Data de referência: </label>
        <bn-datepicker formControlName="dataReferencia"></bn-datepicker>
      </div>
      <div class="bn-form-group col-4">
        <label class="form-label">Val. limite total: </label>
        <input
          type="text"
          class="form-control"
          formControlName="valorLimiteTotal"
          name="valorLimiteTotal"
          bnMask="MOEDA"
        />
      </div>
    </div>
    <div class="row" *ngIf="temTipoLimiteSelecionado">
      <div class="bn-form-group col-md-12">
        <label class="form-label">Comentários ou justificativa</label>
        <textarea
          minlength="2"
          maxlength="1000"
          class="form-control"
          name="comentario"
          rows="4"
          formControlName="comentarios"
        ></textarea>
      </div>
    </div>
  </form>
  <div class="container" *ngIf="ocorrencias?.length > 0">
	<div class="table-responsive">
		<table class="table-striped table-bordered">
			<thead>
				<tr>
					<th class="text-center">Erro(s) encontrado(s)</th>
				</tr>
			</thead>
			<tbody>
				<tr *ngFor="let ocorrencia of ocorrencias">
					<td>{{ ocorrencia.mensagem }}</td>
				</tr>
			</tbody>
		</table>
	</div>
</div>
</section>
